module.exports = __webpack_public_path__ + "img/mp.1b6fab8b.svg";